var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ra-card',[_c('template',{slot:"header"},[_c('p',[_vm._v("Logins By Type")])]),_c('template',{slot:"content"},[(_vm.dataAvailable)?_c('doughnut-chart',{attrs:{"data":_vm.requestChart.data,"labels":_vm.requestChart.labels,"height":200}}):_c('ra-empty-state',{attrs:{"type":'pie-chart'}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }